import { UNIT_TYPE } from '@/types/store/const'
import { TUnitTypeState } from '@/types/store/state' 

// Types 
const INITIAL_STATE: TUnitTypeState = {
    unitType: 0, 
  }

export const workorderReducer: any = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case UNIT_TYPE:
      return {
        ...state,
        unitType: action.payload.unitType, 
      }
    default:
      return state
  }
}